import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    const params = new URLSearchParams(window.location.search);
    const section = params.get('section');
    if (!section) {
      return;
    }

    const target = document.getElementById(`walkthrough-step-${section}`);
    if (target) {
      target.scrollIntoView({ block: 'start' });
    }

    if (target && params.get('video') === 'true') {
      this.#cleanUpVideoParam();
      setTimeout(() => {
        target.querySelector('.walkthrough-page__step-image-link')?.click();
      }, 0);
    }
  }

  #cleanUpVideoParam() {
    const url = new URL(window.location.href);
    url.searchParams.delete('video');
    window.history.replaceState({}, '', url);
  }
}
